
// src/store/configureStore.js

import { createStore, applyMiddleware, compose } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'

import reducers from '../reducers'

const loggerMiddleware = createLogger()

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(history = undefined) {
  var middlewares = [thunkMiddleware]
  if (process.env == 'development')
    middlewares.push(loggerMiddleware)
  if (history)
    middlewares.push(routerMiddleware(history))
  return createStore(
    reducers,
    composeEnhancers(
      applyMiddleware(...middlewares)
    ),
  )
}




// WEBPACK FOOTER //
// ./src/store/configureStore.js